export default __webpack_public_path__ + "static/jack-736bd27e5d5bcc7199819a1e08cd40e0.jpg";